export default function (instance) {
    return {
        getReservations(params = null){
            return instance.get('reservation', params)
        },
        getReservation(id){
            return instance.get('reservation/'+id)
        },
        getTrainer(id){
            return instance.get('trainer/'+id)
        },
        getSchedule(id){
            return instance.get('schedule/'+id)
        },
        postSchedule(id){
            return instance.postForm('schedule', {training: id})
        },
        deleteSchedule(id){
            return instance.delete('schedule/'+id)
        },
        getScheduleList(params = null) {
            return instance.get('schedule', params)
        },
        getScheduleFilters(params = null) {
            return instance.get('schedule/filters', params)
        },
        getScheduleClubs() {
            return instance.get('schedule/clubs')
        },
        getScheduleReasons(id) {
            return instance.get('schedule/' + id + '/reasons')
        },
        postRegistration(scheduleId, extraParams = {}) {
            return instance.post('schedule/registration-v2', { schedule_id: scheduleId, ...extraParams })
        },
        postRegistrationCheck(scheduleId, extraParams = {}) {
            return instance.post('schedule/registration-check', { schedule_id: scheduleId, ...extraParams })
        },
        postGuestRegistration(eventId, phone, clubId) {
            return instance.post('schedule/registration-guest', { event_id: eventId, phone: phone, club_id: clubId })
        },
        deleteRegistration(signId) {
            return instance.delete('schedule/' + signId)
        },
    }
}